import React from 'react';
import Button from './Button';
import Caption from './Caption';
import * as styles from './ShareModal.module.scss';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { getHeroFromAnswers, sendEvent } from '../utils/utils';
import { useGlobalState } from '../state/globalStateContext';

interface ShareModalProps {
  shareUrl: string;
  onCloseClick: () => void;
}

const ShareModal = ({ shareUrl, onCloseClick }: ShareModalProps): React.ReactElement => {
  const { currentScreen, answers, selectedGender } = useGlobalState();
  return (
    <div className={styles.container}>
      <Caption className={styles.caption}>Meanwhile...</Caption>
      <div className={styles.shareContainer}>
        <p className={styles.shareLabel}>Share with your friends</p>
        <div className={styles.shareButtonsContainer}>
          <FacebookShareButton
            resetButtonStyle
            url={shareUrl + '?source=facebook'}
            hashtag="#infosys"
            onClick={() => {
              sendEvent(
                'ClickShareButton',
                {
                  button: 'facebook',
                  screen: currentScreen,
                  hero:
                    currentScreen === 'result'
                      ? getHeroFromAnswers(answers) + '-' + selectedGender
                      : null,
                },
                true,
              );
            }}
          >
            <Button className={styles.shareButton} compact>
              Facebook
            </Button>
          </FacebookShareButton>
          <LinkedinShareButton
            resetButtonStyle
            url={shareUrl + '?source=linkedin'}
            onClick={() => {
              sendEvent(
                'ClickShareButton',
                {
                  button: 'linkedin',
                  screen: currentScreen,
                  hero:
                    currentScreen === 'result'
                      ? getHeroFromAnswers(answers) + '-' + selectedGender
                      : null,
                },
                true,
              );
            }}
          >
            <Button className={styles.shareButton} compact>
              LinkedIn
            </Button>
          </LinkedinShareButton>
          <TwitterShareButton
            resetButtonStyle
            url={shareUrl + '?source=twitter'}
            hashtags={['infosys']}
            onClick={() => {
              sendEvent(
                'ClickShareButton',
                {
                  button: 'twitter',
                  screen: currentScreen,
                  hero:
                    currentScreen === 'result'
                      ? getHeroFromAnswers(answers) + '-' + selectedGender
                      : null,
                },
                true,
              );
            }}
          >
            <Button className={styles.shareButton} compact>
              Twitter
            </Button>
          </TwitterShareButton>
        </div>
      </div>
      <div className={styles.closeButtonContainer}>
        <Button className={styles.closeButton} small onClick={onCloseClick}>
          x
        </Button>
      </div>
    </div>
  );
};

export default ShareModal;
